<template>
  <v-dialog
    v-model="$store.state.navigation.pageLoader"
    persistent
    :width="dialogWidth ? dialogWidth : 300"
  >
    <v-card
      color="primary"
      dark
    >
      <v-card-text>
        <h1>{{ loaderText ? loaderText : defaultLoaderText }}</h1>
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PageLoader',
  props: ['loaderText', 'dialogWidth'],
  data () {
    return {
      defaultLoaderText: 'Please stand by'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/loaders/PageLoader.vue